import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../reducers/user.reducer';
import { RootState, UserState } from '../types/store.types';

export const useUserStore = () => {
  const userStore = useSelector<RootState, UserState>((state) => state.user);
  const dispatch = useDispatch();
  const {
    signIn,
    loggedOut,
    updateDomain,
    updateToken,
    updateLoading,
    updateUserInfo,
    updateCrewRates,
    updateCrewRatesLoading,
    updateZipCode,
    updateCurrentBranch,
    updateUpSellDownSellPrice,
    handleBranchUpdateNew,
    updateVersion,
    updateFeatureAccess,
  } = userActions;

  return {
    signIn,
    loggedOut,
    dispatch,
    userStore,
    updateDomain,
    updateToken,
    updateLoading,
    updateUserInfo,
    updateCrewRates,
    updateCrewRatesLoading,
    updateZipCode,
    updateCurrentBranch,
    updateUpSellDownSellPrice,
    handleBranchUpdateNew,
    updateVersion,
    updateFeatureAccess,
  };
};
